import Sidebar from '../components/Sidebar';

export default function Dashboard() {
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <h1 style={styles.bemVindo}>Olá, {usuario.nome}!</h1>
        <p style={styles.subtitulo}>Selecione uma opção no menu para começar.</p>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  bemVindo: { fontSize: '24px', color: '#1a1a2e', marginBottom: '8px' },
  subtitulo: { color: '#888', fontSize: '15px' },
};